<template lang="pug">
.setup-options.pa-5
  v-row
    v-col
      v-container.pa-0
        v-row
          v-col
            h2.primary--text {{ $t('Chart.setupOptions') }}
        template(v-for="baseField in allFields")
          v-row
            v-col.py-0
              h3.primaryHover--text {{ $tCheck(`chartTitles.${baseField.name}`, $camelToString(baseField.name)) }}
          v-row
            v-col.option-field(v-for="field in baseField.fields", cols="3")
              foo-field(
                :label="$tCheck(`chartOptions.${field.name}`, field.name)",
                :type="field.type",
                :value="getValue(field, baseField)",
                @input="input($event, field, baseField)",
                :inputValue="getValue(field, baseField)",
                @change="change(!!$event, field, baseField)",
                :items="field.options || []",
                :key="`${baseField.name}${field.name}`"
              )
    v-col.d-flex(cols="auto")
      v-row.py-3
        advanced-keys(v-model="selectedOptions", v-bind="{ options }")
</template>

<style lang="scss" scoped>
.setup-options {
  .option-field {
    padding-top: 5px;
    padding-bottom: 5px;
  }
  .advanced-keys {
    font-size: 12px;
  }
}
</style>

<script>
import AdvancedKeys from '@/components/Chart/AdvancedKeys';

export default {
  components: {
    AdvancedKeys,
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    baseOptions: {
      type: Array,
      default: () => ([]),
    },
    options: {
      type: Array,
      default: () => ([]),
    },
  },
  data: () => ({
    selectedOptions: [],
  }),
  computed: {
    allFields() {
      return [...(this.baseOptions || []), ...(this.selectedOptions|| [])];
    },
  },
  methods: {
    getValue(field, baseField) {
      const objectPath =  this.getPath(field, baseField);
      return _.get(this.value, objectPath);
    },
    input($event, field, baseField) {
      const copyVal = _.cloneDeep(this.value);
      const objectPath =  this.getPath(field, baseField);
      _.set(copyVal, objectPath, $event);
      this.$emit('input', copyVal);
    },
    change($event, field, baseField) {
      if (field.type === 'Boolean') {
        this.input($event, field, baseField);
      }
    },
    getPath({ name }, { type: bType, name: bName }) {
      const objectPath =  bType === 'Object' ? `${bName}.` : '';
      return `${objectPath}${name}`;
    },
  },
}
</script>
